<div class="tab-pane folay-horizontal-desktop show active pt-4 pt-md-0" *transloco="let t;">
	<div class="folay-top d-table px-3 px-md-4 text-center mt-2 mt-md-0">
		<div class="topbar">
			<div class="topbar-left-action text-dark">
                <ion-icon name="chevron-back" class="f24" (click)="back();" />
			</div>
		</div>

		<div class="folay-title d-table-row f24">
			<img class="mb-4" src="/assets/images/icon/upstation-black.svg" alt="UP Station Logo" loading="lazy">
			
			<div class="fsemibold">{{ t('modal.auth.welcome') }}</div>
			<div class="folay-subtitle">{{ t('modal.auth.browse_article') }}</div>
		</div>
	</div>

	<div class="folay-dark-container mt-3 mt-md-0">
		@if (isLogin) {
			<form [formGroup]="form">
				<div class="form-group input-underline">
					<label class="text-white">{{ t('form.' + form.value.strategy) }}</label>

					<div class="d-flex align-items-center">
						<input class="flex-shrink-0 cc-input d-none mr-2 form-control" [class.d-block]="form.value.strategy === 'mobileNumber'" type="text" value="(+{{ form.value.phoneCode }})" readonly />
						<ups-input class="flex-grow-1 my-0" [formControl]="form.controls[form.value.strategy!]" type="text" (input)="format();" />
					</div> 
				</div>

				<ups-password formControlName="password" />

				<a type="button" class="u-body-3 text-primary w-100 text-right my-2" (click)="forgotPassword();">{{ t('button.auth.forgot_password') }}</a>
				<button class="btn btn-thumb btn-primary btn-block mt-4 fsemibold" (click)="login();" #btn>{{ t('button.auth.signin') }}</button>
			</form>
		} @else {
			<button id="login-btn" class="d-flex btn-thumb align-items-center btn login-btn rounded btn-apple btn-block mt-3 fsemibold" (click)="normalLogin('email');">
                <img class="mr-2" src="/assets/images/navigation/homepage/cs-email-w.svg" alt="{{ t('form.email') }}" loading="lazy">
                <div class="w-100">{{ t('button.auth.email_login') }}</div>
            </button>

            <button class="d-flex btn-thumb align-items-center btn login-btn rounded btn-apple btn-block mt-3 fsemibold" (click)="normalLogin('mobileNumber');">
                <img class="mr-2" src="/assets/images/navigation/homepage/phone.svg" alt="{{ t('form.mobileNumber') }}" loading="lazy">
                <div class="w-100">{{ t('button.auth.phone_login') }}</div>
            </button>

            <button class="d-flex btn-thumb align-items-center btn login-btn rounded btn-apple btn-block mt-3 fsemibold" (click)="socialLogin('google');">
                <img class="mr-2" src="/assets/images/navigation/google-icon.svg" alt="Google" loading="lazy">
                <div class="w-100">{{ t('button.auth.google_login') }}</div>
            </button>

            <button class="d-flex btn-thumb align-items-center btn login-btn rounded btn-apple btn-block mt-3 fsemibold" disabled (click)="socialLogin('facebook');">
                <img class="mr-2" src="/assets/images/navigation/facebook-icon.svg" alt="Facebook" loading="lazy">
                <div class="w-100">{{ t('button.auth.facebook_login') }}</div>
            </button>

            <div class="text-center u-body-3 text-white mt-3">
                {{ t('modal.auth.no_account') }} <a type="button" class="u-body-3 text-primary" (click)="openRegister();">{{ t('modal.auth.register_now') }}</a>
            </div>
		}
	</div>
</div>
